import React, { useEffect, useState } from "react";
import { Modal } from 'react-bootstrap';
import { VideoModal } from "../../components/Modal";
import { OrderApi } from "../../app/api/order.api";



export function UpdateOrderModal({ show, onHide, order, refetch })
{
  const orders = OrderApi();

  const [status, setStatus] = useState(0);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false); 

  const input = (order?.operationType === "cancel") ? { status : "canceled" } : { status : "pending" }; 

  const handleConfirm = async ()=>{

    setStatus(0);
    setIsLoading(true);

    try {
        const {data} = await orders.update(order?.orderId, input );
        if( data.success ){
            setStatus(1);
            setMessage(data.message);
            refetch();
        }
        else{
            setStatus(-1);
            setMessage('Erreur ! veuillez réessayer');
        }
    } catch (err) { 
        
        setStatus(-1);
        setMessage(err?.response?.data.message);
    } finally{
        setIsLoading(false);
    }
  }

  return(

      <Modal show={show} onHide={onHide} centered backdrop="static">
        <Modal.Header closeButton className="border-bottom">
          <Modal.Title className="text-green fs-5">
            <i className="bi bi-check-circle-fill text-green me-2"></i>
            {
              ( order?.operationType === "cancel" ) ? "Annulation de commande" : "Restauration de commande"
            }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4">
          <div className="text-center">
            <i className="bi bi-box text-green" style={{ fontSize: '3rem' }}></i>
            <p className="mt-3 text-secondary">
            {
              ( order?.operationType === "cancel" ) ? "Êtes-vous sûr de vouloir annuler cette commande ?" : "Êtes-vous sûr de vouloir restaurer cette commande ?"
            }
             
            </p>
            <p className="text-muted">
              <strong> Ref commande : </strong> { order?.orderRef }
            </p>
            {
              isLoading && (
                <div className="d-flex justify-content-center mb-2"> 
                  <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
                </div>
              )
            }
            {
              status === 1 && (
                <div className="alert alert-success mb-2 small w-100"> { message } </div>
              )
            }
            {
              status === -1 && (
                <div className="alert alert-danger mb-2 small w-100"> { message } </div>
              )
            }
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top gap-2">
          <button className="btn btn-sm btn-outline-danger" onClick={onHide}>  Annuler </button>
          <button className="btn btn-sm btn-green" onClick={ ()=> handleConfirm(order?.operationType)}>
            <i className="bi bi-check-circle me-2"></i>
            {
              ( order?.operationType === "cancel" ) ? "Confirmer annulation" : "Confirmer restauration"
            }
          </button>
        </Modal.Footer>
      </Modal>
    )
}



export function ProductModal({ show, onHide, product })
{
    const [showVideo, setShowVideo] = useState(false);
    const [mainImage, setMainImage] = useState(null);
   
     useEffect(() => {
        if (!product) return;
    
        if (Array.isArray(product.images) && product.images.length > 0) {
          setMainImage(product.images[0].url);
        } else {
          setMainImage(null);
        }
      }, [product]);
    
    
      const handleThumbnailClick = (imageUrl) => {
        setMainImage(imageUrl);
      };

    return(

      <Modal show={show} size="xl" onHide={onHide} centered backdrop="static">
        <Modal.Header closeButton className="border-bottom"></Modal.Header>
        <Modal.Body>

            <div className="row">

              {/* Partie Gauche : Images */}
              <div className="col-md-6 p-4">
                <div className="main-image-container mb-3 bg-light d-flex align-items-center justify-content-center">
                   <img src={ mainImage && mainImage } alt="Blue High Hill" className="img-fluid" />
                </div>
                <div className="row g-2 thumb-row">
                {
                  product?.images.map((item, index) => (
                    <div className="col-3" key={index}>
                      <div 
                        className={`thumb ${ mainImage === item.url ? 'active' : '' }`}
                        onClick={() => handleThumbnailClick( item.url )}
                        style={{ cursor: 'pointer', border: mainImage === item.url ? '3px solid black' : 'none' }}
                      >
                        <img src={ item.url } alt={`img-${index + 1}`} className="img-fluid" style={{ maxHeight: '50px' }} />
                      </div>
                    </div>
                  ))
                }
                </div>
              </div>

              {/* Partie Droite : Détails */}
              <div className="col-md-6 p-4 border-start">
                <h3 className="h3"> { product?.name } </h3>
                <div className="title-underline mb-3"></div>
                
                <div className="mb-3" style={{ maxHeight: '250px', overflowY: 'auto', backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px', border: '1px solid #dee2e6' }}>
                  <p className="text-muted">
                     { product?.description }
                  </p>
                </div>
                
                <h3 className="product-price mb-3"> { product?.price + " " + product?.currency } </h3>

                {
                  product?.video !== "" && (
                    <button className="btn btn-outline-green mb-4 px-3" onClick={ ()=> setShowVideo(true) }>
                      <i className="bi bi-play-circle-fill me-2"></i> Lire vidéo
                    </button> 
                  )
                }

                {/* Social */}
                <div className="social-share d-flex gap-2 pt-3 border-top">
                  <div className="social-circle"><i className="bi bi-facebook"></i></div>
                  <div className="social-circle"><i className="bi bi-twitter"></i></div>
                  <div className="social-circle"><i className="bi bi-linkedin"></i></div>
                  <div className="social-circle"><i className="bi bi-google"></i></div>
                  <div className="social-circle"><i className="bi bi-envelope"></i></div>
                </div>
              </div>
            </div>

            {/* Modal de Demande de Maintenance */}
            {
              product?.video && ( <VideoModal show={showVideo} onHide={() => setShowVideo(false)} video={ product?.video } /> )
            }  

        </Modal.Body>
      </Modal>
    )
}




export function LoaderModal({ show, message = 'Chargement...' })
{
    return(
      <Modal show={show} centered backdrop="static" keyboard={false}>
        <Modal.Body className="py-5">
          <div className="text-center">
            <div className="spinner-border text-green mb-3" style={{ width: '80px', height: '80px' }} role="status">
              <span className="visually-hidden">Chargement...</span>
            </div>
            <p className="text-secondary mt-3">{ message }</p>
          </div>
        </Modal.Body>
      </Modal>
    )
}




export function ExtraLoaderModal({ show, message = 'Chargement...', isLoading, status, response })
{
    return(
      <Modal show={show} centered backdrop="static" keyboard={false}>
        <Modal.Body className="py-5">
          {
            isLoading && (
              <div className="text-center">
                <div className="spinner-border text-green mb-3" style={{ width: '80px', height: '80px' }} role="status">
                  <span className="visually-hidden">Chargement...</span>
                </div>
                <p className="text-secondary mt-3">{ message }</p>
              </div>
            )
          } 
          { 
            ( status === 1 ) && (
              <div className="d-flex flex-column align-items-center">
                <i className="bi bi-check-circle display-1" style={{ color:"#307072" }} ></i>
                <h2 className="text-green">Succès !</h2>
                <p className="text-green mt-1">{ response }</p>
                <p className="redirect-text">Redirection vers la liste des commandes dans 4 secondes...</p>
              </div>
            )
          }
          { 
            ( status === -1 ) && (
              <div className="d-flex flex-column align-items-center">
                <i className="bi bi-x-circle text-danger display-1"></i>
                <h2 className="text-danger">Erreur !</h2>
                <p className="text-danger mt-1">{ response }</p>
              </div>
            )
          }
          
        </Modal.Body>
      </Modal>
    )
}